import React from 'react';
import hoc from './FieldHOC';

class SelectField extends React.Component {
  constructor(props) {
    super(...arguments);
    let options = this.props.field.get('options');
    let selected = options.first();
    options.each(option => {
      if (option.get('selected')) {
        selected = option;
      }
    });
    if (props.value) {
      selected = options.get(props.value);
    }
    if (selected) {
      props.field.setSelectedValue(selected.getCurrencyValue());

      this.state = {
        value: selected.get('id')
      };
    } else {
      this.state = {value: ''};
    }
  }

  onChange(e) {
    let selected = this.props.field.get('options').get(e.target.value);
    this.props.field.setSelectedValue(selected.getCurrencyValue());
    this.props.onChange(selected);
    this.setState({
      value: e.target.value
    });
  }

  render() {
    let field = this.props.field;

    let options = field.get('options').map(option => {
      const title = this.props.language === 'french' && option.get('name_french') ? option.get('name_french') : option.get('name');
      return (
        <option key={`option-${option.get('id')}`} value={option.get('id')}>
          {title}
        </option>
      );
    });

    return (
      <div>
        <label htmlFor={this.props.name}>{this.props.title || field.get('title')}</label>
        {this.props.errorComponent}
        <select
          aria-label={this.props.title || field.get('title')}
          className="form-control"
          value={this.state.value}
          name={this.props.name}
          tabIndex={this.props.tabIndex}
          onChange={this.onChange.bind(this)}
          disabled={this.props.disabled}
        >
          {options}
        </select>
      </div>
    );
  }
}

export default hoc(SelectField);
